import React from 'react'
import { Helmet } from 'react-helmet'
//import ThemeSelector from '../../components/ThemeSelector'
import { ThemeSelector,Navbar, Footer, Landing, About, Skills, Testimonials, Blog, Education, Experience, Contacts, Projects, Services, Achievement } from '../../components'
import { headerData } from '../../data/headerData'

function Main() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Porfolio</title>
            </Helmet>

            <Navbar />
            {/* <ThemeSelector />         */}
            <Landing />
            <About />
            <Skills />
            <Experience />            
            {/* <Projects /> */}
            <Achievement />
            <Blog />
            <Contacts />
            {/* <Footer /> */}
        </div>
    )
}

export default Main
